import { render, staticRenderFns } from "./BackendErrorComponent.vue?vue&type=template&id=79ae3095&scoped=true&"
import script from "./BackendErrorComponent.vue?vue&type=script&lang=js&"
export * from "./BackendErrorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae3095",
  null
  
)

export default component.exports